import { pipe } from 'fp-ts/function';
import { array } from 'fp-ts';
import { WithEnterpriseId, WithServiceId } from '@mews-commander/types';
import { RateType, useRepositoryQuery } from '@mews-commander/data-access';
import { orderOrderableEntityArray } from '@mews-commander/legacy-entities/src/utils/orderableEntities';

export const useGetRates = ({ serviceId, enterpriseId }: WithServiceId & WithEnterpriseId) =>
    useRepositoryQuery(
        'rates',
        'getAll',
        {
            serviceIds: [serviceId],
            enterpriseIds: [enterpriseId],
        },
        {
            select: ({ rates }) =>
                rates
                    ? pipe(
                          rates,
                          array.filter((rate) => rate.type === RateType.Public),
                          orderOrderableEntityArray
                      )
                    : [],
        }
    );
